<template>
	<div
		:class="typeStyle"
		style="display: flex"
		class="items-start gap-2 p-2 rounded-md relative"
	>
		<MessageIcon
			:type="type"
			:size="size"
		/>
		<div>
			<div>
				<label
					v-if="title"
					:class="size === 'sm' ? 'text-s-bold' : 'text-default-bold'"
					>{{ title }}</label
				>
				<p
					v-if="description"
					:class="size === 'sm' ? 'text-s' : 'text-default'"
				>
					{{ description }}
				</p>
			</div>
			<div
				v-if="actions?.length"
				class="flex gap-4 justify-end w-full mt-2 sticky"
			>
				<span
					v-for="action in actions"
					:key="action.label"
					class="text-button cursor-pointer"
				>
					{{ action.label }}</span
				>
			</div>
		</div>
		<Icon
			v-if="closeable"
			icon="maki:cross"
			class="text-[12px] mt-1.5 mr-2 cursor-pointer w-fit h-fit absolute right-0"
			:class="`text-${colorIcon}`"
		/>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { computed, ref } from 'vue'
import MessageIcon from './MessageIcon.vue'

const props = defineProps({
	size: String,
	title: String,
	description: String,
	actions: Array,
	type: String,
	closeable: Boolean,
	hideIcon: Boolean,
	iconSize: Number,
})

const colors = ref({
	info: 'blue-tints',
	warning: 'yellow-caution-medium',
	success: 'green-primary-shade-1',
	error: 'red-danger',
})

const styles = ref({
	info: 'bg-blue-tint-4 border border-blue-tints',
	warning: 'bg-yellow-caution-light border border-yellow-caution-medium',
	success: 'bg-green-primary-tint-3 border border-green-primary-shade-1',
	error: 'bg-red-danger-light border border-red-danger',
})

const typeStyle = computed(() => {
	return styles.value[props.type]
})

const colorIcon = computed(() => {
	return colors.value[props.type]
})
</script>

<style></style>
